
    const csCZ = {
        "letterA":
            {
                "sound":
                    {
                        "html5": true,
                        "src": "audio/cs-CZ/Adriana/letterA.mp3",
                        "volume": 1,
                        "preload": true
                    },
                "colour": "#201923",
                "Upper": "A",
                "images":
                    [
                        {
                            "width": "40",
                            "height": "50",
                            "spriteSheeet": "images/fruits.jpg",
                            "backgroundPositionX": "-53",
                            "centerBackgroundPositionX": "-53",
                            "backgroundPositionY": "-62",
                            "centerBackgroundPositionY": "-62",
                            "backgroundSize": "600%",
                            "type": "Ananas",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/food/FruitsAndVegetables_024_Ananas.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "55",
                            "height": "50",
                            "spriteSheeet": "images/toys.svg",
                            "backgroundPositionX": "-59",
                            "centerBackgroundPositionX": "-54",
                            "backgroundPositionY": "-69",
                            "centerBackgroundPositionY": "-63",
                            "backgroundSize": "550%",
                            "type": "Auto",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/toys/Toys_007_Auto.mp3",
                                    "volume": 1,
                                    "preload": true
                                },
                            "soundEffect":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/toys/soundEffects/horn-hooter-94444.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "80",
                            "height": "50",
                            "spriteSheeet": "images/musicalInstruments.svg",
                            "backgroundPositionX": "-301",
                            "centerBackgroundPositionX": "-188",
                            "backgroundPositionY": "-190",
                            "centerBackgroundPositionY": "-120",
                            "backgroundSize": "500%",
                            "type": "Akordeon",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/musicalInstruments/MusicalInstruments_001_Akordeon.mp3",
                                    "volume": 1,
                                    "preload": true
                                },
                            "soundEffect":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/musicalInstruments/soundEffects/winbandoneon-96337.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "90",
                            "height": "50",
                            "spriteSheeet": "images/transportation.svg",
                            "backgroundPositionX": "-73",
                            "centerBackgroundPositionX": "-41",
                            "backgroundPositionY": "-134",
                            "centerBackgroundPositionY": "-74",
                            "backgroundSize": "400%",
                            "type": "Autobus",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/transportation/Transportation_001_Autobus.mp3",
                                    "volume": 1,
                                    "preload": true
                                },
                            "soundEffect":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/transportation/soundEffects/bus-arrival-71991.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        }
                    ]
            },
        "letterB":
            {
                "sound":
                    {
                        "html5": true,
                        "src": "audio/cs-CZ/Adriana/letterB.mp3",
                        "volume": 1,
                        "preload": true
                    },
                "colour": "#228c68",
                "Upper": "B",
                "images":
                    [
                        {
                            "width": "50",
                            "height": "50",
                            "spriteSheeet": "images/colourBlots.svg",
                            "backgroundPositionX": "-122",
                            "centerBackgroundPositionX": "-122",
                            "backgroundPositionY": "-131",
                            "centerBackgroundPositionY": "-131",
                            "backgroundSize": "475%",
                            "type": "Bílá",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/colours/Colours_011_Bila.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "50",
                            "height": "50",
                            "spriteSheeet": "images/vegetables.jpg",
                            "backgroundPositionX": "4",
                            "centerBackgroundPositionX": "4",
                            "backgroundPositionY": "-3",
                            "centerBackgroundPositionY": "-3",
                            "backgroundSize": "450%",
                            "type": "Brokolice",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/food/FruitsAndVegetables_001_Brokolice.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "40",
                            "height": "50",
                            "spriteSheeet": "images/vegetables.jpg",
                            "backgroundPositionX": "-100",
                            "centerBackgroundPositionX": "-100",
                            "backgroundPositionY": "-1",
                            "centerBackgroundPositionY": "-1",
                            "backgroundSize": "500%",
                            "type": "Brambora",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/food/FruitsAndVegetables_004_Brambora.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "45",
                            "height": "50",
                            "spriteSheeet": "images/vegetables.jpg",
                            "backgroundPositionX": "-2",
                            "centerBackgroundPositionX": "-2",
                            "backgroundPositionY": "-70",
                            "centerBackgroundPositionY": "-70",
                            "backgroundSize": "550%",
                            "type": "Bok Choy",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/food/FruitsAndVegetables_007_BokChoy.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "35",
                            "height": "50",
                            "spriteSheeet": "images/fruits.jpg",
                            "backgroundPositionX": "-148",
                            "centerBackgroundPositionX": "-148",
                            "backgroundPositionY": "-64",
                            "centerBackgroundPositionY": "-64",
                            "backgroundSize": "700%",
                            "type": "Banán",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/food/FruitsAndVegetables_026_Banan.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "55",
                            "height": "50",
                            "spriteSheeet": "images/toys.svg",
                            "backgroundPositionX": "-13",
                            "centerBackgroundPositionX": "-11",
                            "backgroundPositionY": "-155",
                            "centerBackgroundPositionY": "-141",
                            "backgroundSize": "650%",
                            "type": "Bagr",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/toys/Toys_011_Bagr.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "55",
                            "height": "50",
                            "spriteSheeet": "images/animals.svg",
                            "backgroundPositionX": "-2",
                            "centerBackgroundPositionX": "-4",
                            "backgroundPositionY": "-302",
                            "centerBackgroundPositionY": "-274",
                            "backgroundSize": "1000%",
                            "type": "Bizon",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/animals/Animals_029_Bizon.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        }
                    ]
            },
        "letterC":
            {
                "colour": "#37294f",
                "sound":
                    {
                        "html5": true,
                        "src": "audio/cs-CZ/Adriana/letterC.mp3",
                        "volume": 1,
                        "preload": true
                    },
                "Upper": "C",
                "images":
                    [
                        {
                            "width": "35",
                            "height": "50",
                            "spriteSheeet": "images/fruits.jpg",
                            "backgroundPositionX": "-75",
                            "centerBackgroundPositionX": "-75",
                            "backgroundPositionY": "-122",
                            "centerBackgroundPositionY": "-122",
                            "backgroundSize": "700%",
                            "type": "Citrón",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/food/FruitsAndVegetables_029_Citron.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        }
                    ]
            },
        "letterCSoft":
            {
                "colour": "#37294f",
                "sound":
                    {
                        "html5": true,
                        "src": "audio/cs-CZ/Adriana/letterCSoft.mp3",
                        "volume": 1,
                        "preload": true
                    },
                "Upper": "Č",
                "images":
                    [
                        {
                            "width": "50",
                            "height": "50",
                            "spriteSheeet": "images/colourBlots.svg",
                            "backgroundPositionX": "-178",
                            "centerBackgroundPositionX": "-178",
                            "backgroundPositionY": "-6",
                            "centerBackgroundPositionY": "-6",
                            "backgroundSize": "475%",
                            "type": "Červená",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/colours/Colours_004_Cervena.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "50",
                            "height": "50",
                            "spriteSheeet": "images/colourBlots.svg",
                            "backgroundPositionX": "-178",
                            "centerBackgroundPositionX": "-178",
                            "backgroundPositionY": "-131",
                            "centerBackgroundPositionY": "-131",
                            "backgroundSize": "475%",
                            "type": "Černá",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/colours/Colours_012_Cerna.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "40",
                            "height": "50",
                            "spriteSheeet": "images/colourShapes1.svg",
                            "backgroundPositionX": "-49",
                            "centerBackgroundPositionX": "-49",
                            "backgroundPositionY": "-10",
                            "centerBackgroundPositionY": "-10",
                            "backgroundSize": "450%",
                            "type": "Červený kruh",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/colourShapes/ColourShapes_002_CervenyKruh.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "30",
                            "height": "50",
                            "spriteSheeet": "images/vegetables.jpg",
                            "backgroundPositionX": "-36",
                            "centerBackgroundPositionX": "-36",
                            "backgroundPositionY": "-49",
                            "centerBackgroundPositionY": "-49",
                            "backgroundSize": "650%",
                            "type": "Čili paprička",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/food/FruitsAndVegetables_008_CiliPapricka.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "50",
                            "height": "50",
                            "spriteSheeet": "images/vegetables.jpg",
                            "backgroundPositionX": "-116",
                            "centerBackgroundPositionX": "-116",
                            "backgroundPositionY": "-158",
                            "centerBackgroundPositionY": "-158",
                            "backgroundSize": "600%",
                            "type": "Česnek",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/food/FruitsAndVegetables_015_Cesnek.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "120",
                            "height": "50",
                            "spriteSheeet": "images/numbers.svg",
                            "backgroundPositionX": "-6",
                            "centerBackgroundPositionX": "-3",
                            "backgroundPositionY": "-201",
                            "centerBackgroundPositionY": "-190",
                            "backgroundSize": "213%",
                            "type": "Čtyři",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/numbers/Numbers_005_4.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "50",
                            "height": "50",
                            "spriteSheeet": "images/musicalInstruments.svg",
                            "backgroundPositionX": "-312",
                            "centerBackgroundPositionX": "-312",
                            "backgroundPositionY": "-37",
                            "centerBackgroundPositionY": "-37",
                            "backgroundSize": "950%",
                            "type": "Činely",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/musicalInstruments/MusicalInstruments_002_Cinely.mp3",
                                    "volume": 1,
                                    "preload": true
                                },
                            "soundEffect":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/musicalInstruments/soundEffects/electribe-cymbals-slice-19-c6-85173.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "50",
                            "height": "50",
                            "spriteSheeet": "images/colourShapes1.svg",
                            "backgroundPositionX": "-7",
                            "centerBackgroundPositionX": "-7",
                            "backgroundPositionY": "-14",
                            "centerBackgroundPositionY": "-14",
                            "backgroundSize": "400%",
                            "type": "Čtverec",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/shapes/Shapes_001_Ctverec.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        }
                    ]
            },
        "letterD":
            {
                "sound":
                    {
                        "html5": true,
                        "src": "audio/cs-CZ/Adriana/letterD.mp3",
                        "volume": 1,
                        "preload": true
                    },
                "colour": "#ffcba5",
                "Upper": "D",
                "images":
                    [
                        {
                            "width": "65",
                            "height": "50",
                            "spriteSheeet": "images/vegetables.jpg",
                            "backgroundPositionX": "-180",
                            "centerBackgroundPositionX": "-180",
                            "backgroundPositionY": "-175",
                            "centerBackgroundPositionY": "-175",
                            "backgroundSize": "500%",
                            "type": "Dýně",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/food/FruitsAndVegetables_016_Dyne.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "45",
                            "height": "50",
                            "spriteSheeet": "images/fruits.jpg",
                            "backgroundPositionX": "-142",
                            "centerBackgroundPositionX": "-142",
                            "backgroundPositionY": "-2",
                            "centerBackgroundPositionY": "-2",
                            "backgroundSize": "550%",
                            "type": "Dračí ovoce",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/food/FruitsAndVegetables_021_DraciOvoce.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "65",
                            "height": "50",
                            "spriteSheeet": "images/animals.svg",
                            "backgroundPositionX": "-337",
                            "centerBackgroundPositionX": "-259",
                            "backgroundPositionY": "-483",
                            "centerBackgroundPositionY": "-372",
                            "backgroundSize": "1300%",
                            "type": "Dikobraz",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/animals/Animals_030_Dikobraz.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "120",
                            "height": "50",
                            "spriteSheeet": "images/numbers.svg",
                            "backgroundPositionX": "-6",
                            "centerBackgroundPositionX": "-3",
                            "backgroundPositionY": "-103",
                            "centerBackgroundPositionY": "-149",
                            "backgroundSize": "213%",
                            "type": "Dva",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/numbers/Numbers_003_2.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "120",
                            "height": "50",
                            "spriteSheeet": "images/numbers.svg",
                            "backgroundPositionX": "-130",
                            "centerBackgroundPositionX": "-161",
                            "backgroundPositionY": "-201",
                            "centerBackgroundPositionY": "-190",
                            "backgroundSize": "213%",
                            "type": "Devět",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/numbers/Numbers_010_9.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "60",
                            "height": "50",
                            "spriteSheeet": "images/homeObjects.svg",
                            "backgroundPositionX": "-367",
                            "centerBackgroundPositionX": "-306",
                            "backgroundPositionY": "-456",
                            "centerBackgroundPositionY": "-380",
                            "backgroundSize": "1000%",
                            "type": "Deštník",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/homeObjects/Home Objects_001_Destnik.mp3",
                                    "volume": 1,
                                    "preload": true
                                },
                            "soundEffect":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/homeObjects/soundEffects/rain-underneath-umbrella-97410.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "60",
                            "height": "50",
                            "spriteSheeet": "images/transportation.svg",
                            "backgroundPositionX": "-67",
                            "centerBackgroundPositionX": "-56",
                            "backgroundPositionY": "-165",
                            "centerBackgroundPositionY": "-137",
                            "backgroundSize": "450%",
                            "type": "Dvoupatrový autobus",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/transportation/Transportation_002_DvoupatrovyAutobus.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "90",
                            "height": "50",
                            "spriteSheeet": "images/transportation.svg",
                            "backgroundPositionX": "-180",
                            "centerBackgroundPositionX": "-99",
                            "backgroundPositionY": "-224",
                            "centerBackgroundPositionY": "-124",
                            "backgroundSize": "400%",
                            "type": "Dodávka",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/transportation/Transportation_003_Dodavka.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        }
                    ]
            },
        "letterDSoft":
            {
                "sound":
                    {
                        "html5": true,
                        "src": "audio/cs-CZ/Adriana/letterDSoft.mp3",
                        "volume": 1,
                        "preload": true
                    },
                "colour": "#ffcba5",
                "Upper": "Ď",
                "images":
                    [
                        {
                            "width": "57",
                            "height": "50",
                            "spriteSheeet": "images/random/dabel.svg",
                            "backgroundPositionX": "0",
                            "centerBackgroundPositionX": "0",
                            "backgroundPositionY": "0",
                            "centerBackgroundPositionY": "0",
                            "backgroundSize": "100%",
                            "type": "Ďábel",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/random/Random_002_Dabel.mp3",
                                    "volume": 1,
                                    "preload": true
                                },
                            "soundEffect":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/random/soundEffects/evil-shreik-45560.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        }
                    ]
            },
        "letterE":
            {
                "sound":
                    {
                        "html5": true,
                        "src": "audio/cs-CZ/Adriana/letterE.mp3",
                        "volume": 1,
                        "preload": true
                    },
                "colour": "#ffc413",
                "Upper": "E",
                "images":
                    [
                        {
                            "width": "55",
                            "height": "50",
                            "spriteSheeet": "images/dairyProducts.jpg",
                            "backgroundPositionX": "-62",
                            "centerBackgroundPositionX": "-62",
                            "backgroundPositionY": "-65",
                            "centerBackgroundPositionY": "-65",
                            "backgroundSize": "325%",
                            "type": "Ementál",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/dairyProducts/Dairy Products_001_Emental.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "50",
                            "height": "50",
                            "spriteSheeet": "images/colourShapes4.svg",
                            "backgroundPositionX": "-9",
                            "centerBackgroundPositionX": "-9",
                            "backgroundPositionY": "-14",
                            "centerBackgroundPositionY": "-14",
                            "backgroundSize": "400%",
                            "type": "Elipsa",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/shapes/Shapes_012_Elipsa.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        }
                    ]
            },
        "letterF":
            {
                "sound":
                    {
                        "html5": true,
                        "src": "audio/cs-CZ/Adriana/letterF.mp3",
                        "volume": 1,
                        "preload": true
                    },
                "colour": "#f07cab",
                "Upper": "F",
                "images":
                    [
                        {
                            "width": "50",
                            "height": "50",
                            "spriteSheeet": "images/colourBlots.svg",
                            "backgroundPositionX": "-66",
                            "centerBackgroundPositionX": "-66",
                            "backgroundPositionY": "-69",
                            "centerBackgroundPositionY": "-69",
                            "backgroundSize": "475%",
                            "type": "Fialová",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/colours/Colours_006_Fialova.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "50",
                            "height": "50",
                            "spriteSheeet": "images/colourShapes4.svg",
                            "backgroundPositionX": "-9",
                            "centerBackgroundPositionX": "-9",
                            "backgroundPositionY": "-14",
                            "centerBackgroundPositionY": "-14",
                            "backgroundSize": "400%",
                            "type": "Fialová elipsa",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/colourShapes/ColourShapes_013_FialovaElipsa.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "110",
                            "height": "50",
                            "spriteSheeet": "images/musicalInstruments.svg",
                            "backgroundPositionX": "-172",
                            "centerBackgroundPositionX": "-78",
                            "backgroundPositionY": "-49",
                            "centerBackgroundPositionY": "-22",
                            "backgroundSize": "600%",
                            "type": "Flétna",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/musicalInstruments/MusicalInstruments_003_Fletna.mp3",
                                    "volume": 1,
                                    "preload": true
                                },
                            "soundEffect":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/musicalInstruments/soundEffects/flautatravessera-46420.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "90",
                            "height": "50",
                            "spriteSheeet": "images/transportation.svg",
                            "backgroundPositionX": "-228",
                            "centerBackgroundPositionX": "-127",
                            "backgroundPositionY": "-1",
                            "centerBackgroundPositionY": "0",
                            "backgroundSize": "425%",
                            "type": "Formule",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/transportation/Transportation_004_Formule.mp3",
                                    "volume": 1,
                                    "preload": true
                                },
                            "soundEffect":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/transportation/soundEffects/long-beach-indy-car-2014-04-13-20067.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        }
                    ]
            },
        "letterG":
            {
                "sound":
                    {
                        "html5": true,
                        "src": "audio/cs-CZ/Adriana/letterG.mp3",
                        "volume": 1,
                        "preload": true
                    },
                "colour": "#5d4c86",
                "Upper": "G",
                "images":
                    [
                        {
                            "width": "55",
                            "height": "50",
                            "spriteSheeet": "images/fruits.jpg",
                            "backgroundPositionX": "-189",
                            "centerBackgroundPositionX": "-189",
                            "backgroundPositionY": "-4",
                            "centerBackgroundPositionY": "-4",
                            "backgroundSize": "450%",
                            "type": "Guava",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/food/FruitsAndVegetables_022_Guava.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "70",
                            "height": "50",
                            "spriteSheeet": "images/animals.svg",
                            "backgroundPositionX": "-297",
                            "centerBackgroundPositionX": "-212",
                            "backgroundPositionY": "-263",
                            "centerBackgroundPositionY": "-188",
                            "backgroundSize": "925%",
                            "type": "Gepard",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/animals/Animals_021_Gepard.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "35",
                            "height": "50",
                            "spriteSheeet": "images/musicalInstruments.svg",
                            "backgroundPositionX": "-139",
                            "centerBackgroundPositionX": "-139",
                            "backgroundPositionY": "-3",
                            "centerBackgroundPositionY": "-3",
                            "backgroundSize": "500%",
                            "type": "Gramofon",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/musicalInstruments/MusicalInstruments_004_Gramofon.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        }
                    ]
            },
        "letterH":
            {
                "sound":
                    {
                        "html5": true,
                        "src": "audio/cs-CZ/Adriana/letterH.mp3",
                        "volume": 1,
                        "preload": true
                    },
                "colour": "#632819",
                "Upper": "H",
                "images":
                    [
                        {
                            "width": "50",
                            "height": "50",
                            "spriteSheeet": "images/colourBlots.svg",
                            "backgroundPositionX": "-9",
                            "centerBackgroundPositionX": "-9",
                            "backgroundPositionY": "-131",
                            "centerBackgroundPositionY": "-131",
                            "backgroundSize": "475%",
                            "type": "Hnědá",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/colours/Colours_009_Hneda.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "35",
                            "height": "50",
                            "spriteSheeet": "images/vegetables.jpg",
                            "backgroundPositionX": "-159",
                            "centerBackgroundPositionX": "-159",
                            "backgroundPositionY": "-2",
                            "centerBackgroundPositionY": "-2",
                            "backgroundSize": "650%",
                            "type": "Houba",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/food/FruitsAndVegetables_005_Houba.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "30",
                            "height": "50",
                            "spriteSheeet": "images/vegetables.jpg",
                            "backgroundPositionX": "-117",
                            "centerBackgroundPositionX": "-117",
                            "backgroundPositionY": "-60",
                            "centerBackgroundPositionY": "-60",
                            "backgroundSize": "750%",
                            "type": "Hrášek",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/food/FruitsAndVegetables_010_Hrasek.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "40",
                            "height": "50",
                            "spriteSheeet": "images/fruits.jpg",
                            "backgroundPositionX": "-9",
                            "centerBackgroundPositionX": "-9",
                            "backgroundPositionY": "-62",
                            "centerBackgroundPositionY": "-62",
                            "backgroundSize": "600%",
                            "type": "Hroznové víno",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/food/FruitsAndVegetables_023_HroznoveVino.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "45",
                            "height": "50",
                            "spriteSheeet": "images/fruits.jpg",
                            "backgroundPositionX": "-124",
                            "centerBackgroundPositionX": "-124",
                            "backgroundPositionY": "-124",
                            "centerBackgroundPositionY": "-124",
                            "backgroundSize": "550%",
                            "type": "Hruška",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/food/FruitsAndVegetables_030_Hruska.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "65",
                            "height": "50",
                            "spriteSheeet": "images/animals.svg",
                            "backgroundPositionX": "-171",
                            "centerBackgroundPositionX": "-131",
                            "backgroundPositionY": "-268",
                            "centerBackgroundPositionY": "-206",
                            "backgroundSize": "1050%",
                            "type": "Hroch",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/animals/Animals_020_Hroch.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "80",
                            "height": "50",
                            "spriteSheeet": "images/homeObjects.svg",
                            "backgroundPositionX": "-23",
                            "centerBackgroundPositionX": "-15",
                            "backgroundPositionY": "-21",
                            "centerBackgroundPositionY": "-14",
                            "backgroundSize": "800%",
                            "type": "Hrnec",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/homeObjects/Home Objects_002_Hrnec.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "50",
                            "height": "50",
                            "spriteSheeet": "images/homeObjects.svg",
                            "backgroundPositionX": "-189",
                            "centerBackgroundPositionX": "-189",
                            "backgroundPositionY": "-416",
                            "centerBackgroundPositionY": "-416",
                            "backgroundSize": "1100%",
                            "type": "Hřeben",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/homeObjects/Home Objects_003_Hreben.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "50",
                            "height": "50",
                            "spriteSheeet": "images/homeObjects.svg",
                            "backgroundPositionX": "-580",
                            "centerBackgroundPositionX": "-580",
                            "backgroundPositionY": "-582",
                            "centerBackgroundPositionY": "-582",
                            "backgroundSize": "1300%",
                            "type": "Hodiny",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/homeObjects/Home Objects_004_Hodiny.mp3",
                                    "volume": 1,
                                    "preload": true
                                },
                            "soundEffect":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/homeObjects/soundEffects/tic-tac-27828.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "40",
                            "height": "50",
                            "spriteSheeet": "images/transportation.svg",
                            "backgroundPositionX": "1",
                            "centerBackgroundPositionX": "1",
                            "backgroundPositionY": "-33",
                            "centerBackgroundPositionY": "-33",
                            "backgroundSize": "550%",
                            "type": "Horkovzdušný balón",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/transportation/Transportation_005_HorkovzdusnyBalon.mp3",
                                    "volume": 1,
                                    "preload": true
                                },
                            "soundEffect":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/transportation/soundEffects/hotairbaloontorch-60586.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "40",
                            "height": "50",
                            "spriteSheeet": "images/colourShapes4.svg",
                            "backgroundPositionX": "-131",
                            "centerBackgroundPositionX": "-131",
                            "backgroundPositionY": "-9",
                            "centerBackgroundPositionY": "-9",
                            "backgroundSize": "450%",
                            "type": "Hvězda",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/shapes/Shapes_015_Hvezda.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        }
                    ]
            },
        "letterCH":
            {
                "sound":
                    {
                        "html5": true,
                        "src": "audio/cs-CZ/Adriana/letterCH.mp3",
                        "volume": 1,
                        "preload": true
                    },
                "colour": "#8ad8e8",
                "Upper": "CH",
                "images":
                    [
                        {
                            "width": "55",
                            "height": "50",
                            "spriteSheeet": "images/animals.svg",
                            "backgroundPositionX": "-236",
                            "centerBackgroundPositionX": "-215",
                            "backgroundPositionY": "-330",
                            "centerBackgroundPositionY": "-299",
                            "backgroundSize": "1250%",
                            "type": "Chameleon",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/animals/Animals_027_Chameleon.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "55",
                            "height": "50",
                            "spriteSheeet": "images/animals.svg",
                            "backgroundPositionX": "-384",
                            "centerBackgroundPositionX": "-350",
                            "backgroundPositionY": "-412",
                            "centerBackgroundPositionY": "-375",
                            "backgroundSize": "1100%",
                            "type": "Chobotnice",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/animals/Animals_037_Chobotnice.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "55",
                            "height": "50",
                            "spriteSheeet": "images/buildings.svg",
                            "backgroundPositionX": "-114",
                            "centerBackgroundPositionX": "-104",
                            "backgroundPositionY": "-111",
                            "centerBackgroundPositionY": "-101",
                            "backgroundSize": "500%",
                            "type": "Chalupa",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/buildings/Buildings_001_Chalupa.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        }
                    ]
            },
        "letterI":
            {
                "sound":
                    {
                        "html5": true,
                        "src": "audio/cs-CZ/Adriana/letterI.mp3",
                        "volume": 1,
                        "preload": true
                    },
                "colour": "#277da7",
                "Upper": "I",
                "images":
                    [
                        {
                            "width": "70",
                            "height": "50",
                            "spriteSheeet": "images/buildings.svg",
                            "backgroundPositionX": "-34",
                            "centerBackgroundPositionX": "-24",
                            "backgroundPositionY": "-127",
                            "centerBackgroundPositionY": "-139",
                            "backgroundSize": "425%",
                            "type": "Iglú",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/buildings/Buildings_002_Iglu.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        }
                    ]
            },
        "letterJ":
            {
                "sound":
                    {
                        "html5": true,
                        "src": "audio/cs-CZ/Adriana/letterJ.mp3",
                        "volume": 1,
                        "preload": true
                    },
                "colour": "#e68f66",
                "Upper": "J",
                "images":
                    [
                        {
                            "width": "40",
                            "height": "50",
                            "spriteSheeet": "images/fruits.jpg",
                            "backgroundPositionX": "-55",
                            "centerBackgroundPositionX": "-55",
                            "backgroundPositionY": "-4",
                            "centerBackgroundPositionY": "-4",
                            "backgroundSize": "600%",
                            "type": "Jahoda",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/food/FruitsAndVegetables_019_Jahoda.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "55",
                            "height": "50",
                            "spriteSheeet": "images/fruits.jpg",
                            "backgroundPositionX": "-215",
                            "centerBackgroundPositionX": "-188",
                            "backgroundPositionY": "-80",
                            "centerBackgroundPositionY": "-70",
                            "backgroundSize": "500%",
                            "type": "Jablko",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/food/FruitsAndVegetables_027_Jablko.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "45",
                            "height": "50",
                            "spriteSheeet": "images/animals.svg",
                            "backgroundPositionX": "-168",
                            "centerBackgroundPositionX": "-168",
                            "backgroundPositionY": "-94",
                            "centerBackgroundPositionY": "-95",
                            "backgroundSize": "850%",
                            "type": "Jelen",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/animals/Animals_015_Jelen.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "120",
                            "height": "50",
                            "spriteSheeet": "images/numbers.svg",
                            "backgroundPositionX": "-6",
                            "centerBackgroundPositionX": "-3",
                            "backgroundPositionY": "-54",
                            "centerBackgroundPositionY": "-22",
                            "backgroundSize": "213%",
                            "type": "Jedna",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/numbers/Numbers_002_1.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "40",
                            "height": "50",
                            "spriteSheeet": "images/dairyProducts.jpg",
                            "backgroundPositionX": "-10",
                            "centerBackgroundPositionX": "-10",
                            "backgroundPositionY": "-60",
                            "centerBackgroundPositionY": "-60",
                            "backgroundSize": "425%",
                            "type": "Jogurt",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/dairyProducts/Dairy Products_002_Jogurt.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "40",
                            "height": "50",
                            "spriteSheeet": "images/transportation.svg",
                            "backgroundPositionX": "1",
                            "centerBackgroundPositionX": "1",
                            "backgroundPositionY": "-95",
                            "centerBackgroundPositionY": "-95",
                            "backgroundSize": "450%",
                            "type": "Jachta",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/transportation/Transportation_006_Jachta.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        }
                    ]
            },
        "letterK":
            {
                "sound":
                    {
                        "html5": true,
                        "src": "audio/cs-CZ/Adriana/letterK.mp3",
                        "volume": 1,
                        "preload": true
                    },
                "colour": "#f47a22",
                "Upper": "K",
                "images":
                    [
                        {
                            "width": "70",
                            "height": "50",
                            "spriteSheeet": "images/toys.svg",
                            "backgroundPositionX": "-93",
                            "centerBackgroundPositionX": "-66",
                            "backgroundPositionY": "-14",
                            "centerBackgroundPositionY": "-10",
                            "backgroundSize": "550%",
                            "type": "Kolo",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/toys/Toys_002_Kolo.mp3",
                                    "volume": 1,
                                    "preload": true
                                },
                            "soundEffect":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/transportation/soundEffects/bicycle_bell-32072.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "50",
                            "height": "50",
                            "spriteSheeet": "images/toys.svg",
                            "backgroundPositionX": "-229",
                            "centerBackgroundPositionX": "-229",
                            "backgroundPositionY": "-8",
                            "centerBackgroundPositionY": "-8",
                            "backgroundSize": "700%",
                            "type": "Koloběžka",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/toys/Toys_004_Kolobezka.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "40",
                            "height": "50",
                            "spriteSheeet": "images/vegetables.jpg",
                            "backgroundPositionX": "-141",
                            "centerBackgroundPositionX": "-141",
                            "backgroundPositionY": "-58",
                            "centerBackgroundPositionY": "-58",
                            "backgroundSize": "550%",
                            "type": "Kukuřice",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/food/FruitsAndVegetables_011_Kukurice.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "65",
                            "height": "50",
                            "spriteSheeet": "images/vegetables.jpg",
                            "backgroundPositionX": "-223",
                            "centerBackgroundPositionX": "-223",
                            "backgroundPositionY": "-155",
                            "centerBackgroundPositionY": "-155",
                            "backgroundSize": "450%",
                            "type": "Kokosový ořech",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/food/FruitsAndVegetables_017_KokosovyOrech.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "45",
                            "height": "50",
                            "spriteSheeet": "images/animals.svg",
                            "backgroundPositionX": "-261",
                            "centerBackgroundPositionX": "-260",
                            "backgroundPositionY": "-6",
                            "centerBackgroundPositionY": "-5",
                            "backgroundSize": "1000%",
                            "type": "Kohout",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/animals/Animals_003_Kohout.mp3",
                                    "volume": 1,
                                    "preload": true
                                },
                            "soundEffect":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/animals/soundEffects/cock-rooster-cockerel-scream-sound-100787.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "45",
                            "height": "50",
                            "spriteSheeet": "images/animals.svg",
                            "backgroundPositionX": "0",
                            "centerBackgroundPositionX": "0",
                            "backgroundPositionY": "-111",
                            "centerBackgroundPositionY": "-113",
                            "backgroundSize": "1000%",
                            "type": "Klokan",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/animals/Animals_010_Klokan.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "35",
                            "height": "50",
                            "spriteSheeet": "images/animals.svg",
                            "backgroundPositionX": "-9",
                            "centerBackgroundPositionX": "-9",
                            "backgroundPositionY": "-13",
                            "centerBackgroundPositionY": "-13",
                            "backgroundSize": "1800%",
                            "type": "Koala",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/animals/Animals_001_Koala.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "65",
                            "height": "50",
                            "spriteSheeet": "images/animals.svg",
                            "backgroundPositionX": "-649",
                            "centerBackgroundPositionX": "-500",
                            "backgroundPositionY": "-234",
                            "centerBackgroundPositionY": "-179",
                            "backgroundSize": "1100%",
                            "type": "Krab",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/animals/Animals_024_Krab.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "40",
                            "height": "50",
                            "spriteSheeet": "images/animals.svg",
                            "backgroundPositionX": "-137",
                            "centerBackgroundPositionX": "-137",
                            "backgroundPositionY": "-248",
                            "centerBackgroundPositionY": "-248",
                            "backgroundSize": "1300%",
                            "type": "Kůň",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/animals/Animals_026_Kun.mp3",
                                    "volume": 1,
                                    "preload": true
                                },
                            "soundEffect":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/animals/soundEffects/horse-neigh-shortened-84724.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "60",
                            "height": "50",
                            "spriteSheeet": "images/animals.svg",
                            "backgroundPositionX": "-48",
                            "centerBackgroundPositionX": "-39",
                            "backgroundPositionY": "-331",
                            "centerBackgroundPositionY": "-275",
                            "backgroundSize": "850%",
                            "type": "Kráva",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/animals/Animals_032_Krava.mp3",
                                    "volume": 1,
                                    "preload": true
                                },
                            "soundEffect":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/animals/soundEffects/079276_cow-86620.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "35",
                            "height": "50",
                            "spriteSheeet": "images/animals.svg",
                            "backgroundPositionX": "-250",
                            "centerBackgroundPositionX": "-251",
                            "backgroundPositionY": "-453",
                            "centerBackgroundPositionY": "-452",
                            "backgroundSize": "1900%",
                            "type": "Kočka",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/animals/Animals_034_Kocka.mp3",
                                    "volume": 1,
                                    "preload": true
                                },
                            "soundEffect":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/animals/soundEffects/cat-meow-6226.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "50",
                            "height": "50",
                            "spriteSheeet": "images/homeObjects.svg",
                            "backgroundPositionX": "-305",
                            "centerBackgroundPositionX": "-305",
                            "backgroundPositionY": "-11",
                            "centerBackgroundPositionY": "-11",
                            "backgroundSize": "1000%",
                            "type": "Konvice",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/homeObjects/Home Objects_005_Konvice.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "90",
                            "height": "50",
                            "spriteSheeet": "images/transportation.svg",
                            "backgroundPositionX": "-1",
                            "centerBackgroundPositionX": "-1",
                            "backgroundPositionY": "-175",
                            "centerBackgroundPositionY": "-98",
                            "backgroundSize": "500%",
                            "type": "Kolo",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/transportation/Transportation_007_Kolo.mp3",
                                    "volume": 1,
                                    "preload": true
                                },
                            "soundEffect":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/transportation/soundEffects/bicycle_bell-32072.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "70",
                            "height": "50",
                            "spriteSheeet": "images/transportation.svg",
                            "backgroundPositionX": "-257",
                            "centerBackgroundPositionX": "-184",
                            "backgroundPositionY": "-127",
                            "centerBackgroundPositionY": "-90",
                            "backgroundSize": "475%",
                            "type": "Kamion",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/transportation/Transportation_010_Kamion.mp3",
                                    "volume": 1,
                                    "preload": true
                                },
                            "soundEffect":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/transportation/soundEffects/zur_pfx_truck_horns_different_ms-73563.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "40",
                            "height": "50",
                            "spriteSheeet": "images/colourShapes1.svg",
                            "backgroundPositionX": "-49",
                            "centerBackgroundPositionX": "-49",
                            "backgroundPositionY": "-10",
                            "centerBackgroundPositionY": "-10",
                            "backgroundSize": "450%",
                            "type": "Kruh",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/shapes/Shapes_002_Kruh.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "40",
                            "height": "50",
                            "spriteSheeet": "images/colourShapes2.svg",
                            "backgroundPositionX": "-50",
                            "centerBackgroundPositionX": "-50",
                            "backgroundPositionY": "-8",
                            "centerBackgroundPositionY": "-8",
                            "backgroundSize": "450%",
                            "type": "Kosočtverec",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/shapes/Shapes_006_Kosoctverec.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "40",
                            "height": "50",
                            "spriteSheeet": "images/colourShapes2.svg",
                            "backgroundPositionX": "-131",
                            "centerBackgroundPositionX": "-131",
                            "backgroundPositionY": "-8",
                            "centerBackgroundPositionY": "-8",
                            "backgroundSize": "450%",
                            "type": "Krychle",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/shapes/Shapes_008_Krychle.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "50",
                            "height": "50",
                            "spriteSheeet": "images/colourShapes3.svg",
                            "backgroundPositionX": "-140",
                            "centerBackgroundPositionX": "-140",
                            "backgroundPositionY": "-15",
                            "centerBackgroundPositionY": "-15",
                            "backgroundSize": "400%",
                            "type": "Kosodélník",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/shapes/Shapes_011_Kosodelnik.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        }
                    ]
            },
        "letterL":
            {
                "sound":
                    {
                        "html5": true,
                        "src": "audio/cs-CZ/Adriana/letterL.mp3",
                        "volume": 1,
                        "preload": true
                    },
                "colour": "#d30b94",
                "Upper": "L",
                "images":
                    [
                        {
                            "width": "65",
                            "height": "50",
                            "spriteSheeet": "images/toys.svg",
                            "backgroundPositionX": "-157",
                            "centerBackgroundPositionX": "-121",
                            "backgroundPositionY": "-173",
                            "centerBackgroundPositionY": "-134",
                            "backgroundSize": "600%",
                            "type": "Letadlo dvouplošník",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/toys/Toys_012_LetadloDvouplosnik.mp3",
                                    "volume": 1,
                                    "preload": true
                                },
                            "soundEffect":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/toys/soundEffects/prop-plane-14513.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "55",
                            "height": "50",
                            "spriteSheeet": "images/toys.svg",
                            "backgroundPositionX": "-113",
                            "centerBackgroundPositionX": "-103",
                            "backgroundPositionY": "-67",
                            "centerBackgroundPositionY": "-61",
                            "backgroundSize": "550%",
                            "type": "Letadlo s vrtulí",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/toys/Toys_008_LetadloSVrtuli.mp3",
                                    "volume": 1,
                                    "preload": true
                                },
                            "soundEffect":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/toys/soundEffects/prop-plane-14513.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "90",
                            "height": "50",
                            "spriteSheeet": "images/toys.svg",
                            "backgroundPositionX": "-174",
                            "centerBackgroundPositionX": "-96",
                            "backgroundPositionY": "-20",
                            "centerBackgroundPositionY": "-12",
                            "backgroundSize": "450%",
                            "type": "Letadlo",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/toys/Toys_003_Letadlo.mp3",
                                    "volume": 1,
                                    "preload": true
                                },
                            "soundEffect":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/toys/soundEffects/small-airplane-flyby-13849.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "30",
                            "height": "50",
                            "spriteSheeet": "images/vegetables.jpg",
                            "backgroundPositionX": "-205",
                            "centerBackgroundPositionX": "-205",
                            "backgroundPositionY": "-4",
                            "centerBackgroundPositionY": "-4",
                            "backgroundSize": "800%",
                            "type": "Lilek",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/food/FruitsAndVegetables_006_Lilek.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "50",
                            "height": "50",
                            "spriteSheeet": "images/animals.svg",
                            "backgroundPositionX": "-1",
                            "centerBackgroundPositionX": "-1",
                            "backgroundPositionY": "-272",
                            "centerBackgroundPositionY": "-272",
                            "backgroundSize": "1200%",
                            "type": "Lev",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/animals/Animals_025_Lev.mp3",
                                    "volume": 1,
                                    "preload": true
                                },
                            "soundEffect":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/animals/soundEffects/roar-47757.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "90",
                            "height": "50",
                            "spriteSheeet": "images/animals.svg",
                            "backgroundPositionX": "-631",
                            "centerBackgroundPositionX": "-750",
                            "backgroundPositionY": "-565",
                            "centerBackgroundPositionY": "-658",
                            "backgroundSize": "800%",
                            "type": "Lachtan",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/animals/Animals_040_Lachtan.mp3",
                                    "volume": 1,
                                    "preload": true
                                },
                            "soundEffect":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/animals/soundEffects/sound-of-a-seal-14648.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "55",
                            "height": "50",
                            "spriteSheeet": "images/homeObjects.svg",
                            "backgroundPositionX": "-186",
                            "centerBackgroundPositionX": "-170",
                            "backgroundPositionY": "-95",
                            "centerBackgroundPositionY": "-87",
                            "backgroundSize": "1000%",
                            "type": "Lžíce",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/homeObjects/Home Objects_006_Lzice.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "40",
                            "height": "50",
                            "spriteSheeet": "images/homeObjects.svg",
                            "backgroundPositionX": "-229",
                            "centerBackgroundPositionX": "-229",
                            "backgroundPositionY": "-209",
                            "centerBackgroundPositionY": "-209",
                            "backgroundSize": "1600%",
                            "type": "Lampa",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/homeObjects/Home Objects_007_Lampa.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "30",
                            "height": "50",
                            "spriteSheeet": "images/homeObjects.svg",
                            "backgroundPositionX": "-103",
                            "centerBackgroundPositionX": "-103",
                            "backgroundPositionY": "-446",
                            "centerBackgroundPositionY": "-446",
                            "backgroundSize": "1700%",
                            "type": "Lednice",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/homeObjects/Home Objects_008_Lednice.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "110",
                            "height": "50",
                            "spriteSheeet": "images/transportation.svg",
                            "backgroundPositionX": "-50",
                            "centerBackgroundPositionX": "-22",
                            "backgroundPositionY": "-30",
                            "centerBackgroundPositionY": "-14",
                            "backgroundSize": "200%",
                            "type": "Letadlo dopravní",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/transportation/Transportation_008_LetadloDopravni.mp3",
                                    "volume": 1,
                                    "preload": true
                                },
                            "soundEffect":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/transportation/soundEffects/airplane-landing-6732.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "110",
                            "height": "50",
                            "spriteSheeet": "images/transportation.svg",
                            "backgroundPositionX": "-352",
                            "centerBackgroundPositionX": "-161",
                            "backgroundPositionY": "-106",
                            "centerBackgroundPositionY": "-49",
                            "backgroundSize": "425%",
                            "type": "Limuzína",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/transportation/Transportation_009_Limuzina.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "50",
                            "height": "50",
                            "spriteSheeet": "images/colourShapes2.svg",
                            "backgroundPositionX": "-8",
                            "centerBackgroundPositionX": "-8",
                            "backgroundPositionY": "-14",
                            "centerBackgroundPositionY": "-14",
                            "backgroundSize": "400%",
                            "type": "Lichoběžník",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/shapes/Shapes_005_Lichobeznik.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        }
                    ]
            },
        "letterM":
            {
                "sound":
                    {
                        "html5": true,
                        "src": "audio/cs-CZ/Adriana/letterM.mp3",
                        "volume": 1,
                        "preload": true
                    },
                "colour": "#fcff5d",
                "Upper": "M",
                "images":
                    [
                        {
                            "width": "50",
                            "height": "50",
                            "spriteSheeet": "images/colourBlots.svg",
                            "backgroundPositionX": "-9",
                            "centerBackgroundPositionX": "-9",
                            "backgroundPositionY": "-6",
                            "centerBackgroundPositionY": "-6",
                            "backgroundSize": "475%",
                            "type": "Modrá",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/colours/Colours_001_Modra.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "50",
                            "height": "50",
                            "spriteSheeet": "images/colourShapes1.svg",
                            "backgroundPositionX": "-143",
                            "centerBackgroundPositionX": "-143",
                            "backgroundPositionY": "-16",
                            "centerBackgroundPositionY": "-16",
                            "backgroundSize": "400%",
                            "type": "Modrý obdélník",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/colourShapes/ColourShapes_004_ModryObdelnik.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "40",
                            "height": "50",
                            "spriteSheeet": "images/colourShapes2.svg",
                            "backgroundPositionX": "-131",
                            "centerBackgroundPositionX": "-131",
                            "backgroundPositionY": "-8",
                            "centerBackgroundPositionY": "-8",
                            "backgroundSize": "450%",
                            "type": "Modrá krychle",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/colourShapes/ColourShapes_008_ModraKrychle.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "50",
                            "height": "50",
                            "spriteSheeet": "images/colourShapes3.svg",
                            "backgroundPositionX": "-51",
                            "centerBackgroundPositionX": "-51",
                            "backgroundPositionY": "-14",
                            "centerBackgroundPositionY": "-14",
                            "backgroundSize": "400%",
                            "type": "Modrý trojúhelník",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/colourShapes/ColourShapes_010_ModryTrojuhelnik.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "35",
                            "height": "50",
                            "spriteSheeet": "images/vegetables.jpg",
                            "backgroundPositionX": "-38",
                            "centerBackgroundPositionX": "-38",
                            "backgroundPositionY": "-1",
                            "centerBackgroundPositionY": "-1",
                            "backgroundSize": "600%",
                            "type": "Mrkev",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/food/FruitsAndVegetables_002_Mrkev.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "40",
                            "height": "50",
                            "spriteSheeet": "images/fruits.jpg",
                            "backgroundPositionX": "-95",
                            "centerBackgroundPositionX": "-95",
                            "backgroundPositionY": "-2",
                            "centerBackgroundPositionY": "-2",
                            "backgroundSize": "590%",
                            "type": "Mango",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/food/FruitsAndVegetables_020_Mango.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "65",
                            "height": "50",
                            "spriteSheeet": "images/fruits.jpg",
                            "backgroundPositionX": "-2",
                            "centerBackgroundPositionX": "-2",
                            "backgroundPositionY": "-113",
                            "centerBackgroundPositionY": "-113",
                            "backgroundSize": "350%",
                            "type": "Meloun",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/food/FruitsAndVegetables_028_Meloun.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "75",
                            "height": "50",
                            "spriteSheeet": "images/fruits.jpg",
                            "backgroundPositionX": "-200",
                            "centerBackgroundPositionX": "-200",
                            "backgroundPositionY": "-146",
                            "centerBackgroundPositionY": "-146",
                            "backgroundSize": "375%",
                            "type": "Mangostan",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/food/FruitsAndVegetables_031_Mangostan.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "60",
                            "height": "50",
                            "spriteSheeet": "images/toys.svg",
                            "backgroundPositionX": "-289",
                            "centerBackgroundPositionX": "-241",
                            "backgroundPositionY": "-9",
                            "centerBackgroundPositionY": "-9",
                            "backgroundSize": "600%",
                            "type": "Mašinka",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/toys/Toys_005_Masinka.mp3",
                                    "volume": 1,
                                    "preload": true
                                },
                            "soundEffect":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/toys/soundEffects/train-railroad-traffic-sound-8002.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "40",
                            "height": "50",
                            "spriteSheeet": "images/animals.svg",
                            "backgroundPositionX": "-500",
                            "centerBackgroundPositionX": "-500",
                            "backgroundPositionY": "-284",
                            "centerBackgroundPositionY": "-284",
                            "backgroundSize": "1600%",
                            "type": "Medúza",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/animals/Animals_028_Meduza.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "40",
                            "height": "50",
                            "spriteSheeet": "images/dairyProducts.jpg",
                            "backgroundPositionX": "-121",
                            "centerBackgroundPositionX": "-121",
                            "backgroundPositionY": "-60",
                            "centerBackgroundPositionY": "-60",
                            "backgroundSize": "425%",
                            "type": "Mléko",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/dairyProducts/Dairy Products_003_Mleko.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "60",
                            "height": "50",
                            "spriteSheeet": "images/dairyProducts.jpg",
                            "backgroundPositionX": "-119",
                            "centerBackgroundPositionX": "-119",
                            "backgroundPositionY": "-5",
                            "centerBackgroundPositionY": "-5",
                            "backgroundSize": "300%",
                            "type": "Máslo",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/dairyProducts/Dairy Products_004_Maslo.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        }
                    ]
            },
        "letterN":
            {
                "sound":
                    {
                        "html5": true,
                        "src": "audio/cs-CZ/Adriana/letterN.mp3",
                        "volume": 1,
                        "preload": true
                    },
                "colour": "#235b54",
                "Upper": "N",
                "images":
                    [
                        {
                            "width": "80",
                            "height": "50",
                            "spriteSheeet": "images/toys.svg",
                            "backgroundPositionX": "-13",
                            "centerBackgroundPositionX": "-8",
                            "backgroundPositionY": "-17",
                            "centerBackgroundPositionY": "-10",
                            "backgroundSize": "500%",
                            "type": "Náklaďák",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/toys/Toys_001_Nakladak.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "65",
                            "height": "50",
                            "spriteSheeet": "images/animals.svg",
                            "backgroundPositionX": "4",
                            "centerBackgroundPositionX": "4",
                            "backgroundPositionY": "-240",
                            "centerBackgroundPositionY": "-184",
                            "backgroundSize": "1000%",
                            "type": "Nosorožec",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/animals/Animals_017_Nosorozec.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "120",
                            "height": "50",
                            "spriteSheeet": "images/numbers.svg",
                            "backgroundPositionX": "-6",
                            "centerBackgroundPositionX": "-3",
                            "backgroundPositionY": "-5",
                            "centerBackgroundPositionY": "-2",
                            "backgroundSize": "213%",
                            "type": "Nula",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/numbers/Numbers_001_0.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "35",
                            "height": "50",
                            "spriteSheeet": "images/bodyParts.svg",
                            "backgroundPositionX": "-6",
                            "centerBackgroundPositionX": "-6",
                            "backgroundPositionY": "-47",
                            "centerBackgroundPositionY": "-47",
                            "backgroundSize": "350%",
                            "type": "Nos",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/bodyParts/Body Parts_001_Nos.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "55",
                            "height": "50",
                            "spriteSheeet": "images/homeObjects.svg",
                            "backgroundPositionX": "-25",
                            "centerBackgroundPositionX": "-24",
                            "backgroundPositionY": "-95",
                            "centerBackgroundPositionY": "-86",
                            "backgroundSize": "1000%",
                            "type": "Nůž",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/homeObjects/Home Objects_009_Nuz.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        }
                    ]
            },
        "letterNSoft":
            {
                "sound":
                    {
                        "html5": true,
                        "src": "audio/cs-CZ/Adriana/letterNSoft.mp3",
                        "volume": 1,
                        "preload": true
                    },
                "colour": "#235b54",
                "Upper": "Ň",
                "images":
                    [
                        {
                            "width": "50",
                            "height": "50",
                            "spriteSheeet": "images/random/nouma.svg",
                            "backgroundPositionX": "0",
                            "centerBackgroundPositionX": "0",
                            "backgroundPositionY": "0",
                            "centerBackgroundPositionY": "0",
                            "backgroundSize": "100%",
                            "type": "Ňouma",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/random/Random_001_Nouma.mp3",
                                    "volume": 1,
                                    "preload": true
                                },
                            "soundEffect":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/random/soundEffects/stupid-person-giggle-100494.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        }
                    ]
            },
        "letterO":
            {
                "sound":
                    {
                        "html5": true,
                        "src": "audio/cs-CZ/Adriana/letterO.mp3",
                        "volume": 1,
                        "preload": true
                    },
                "colour": "#3750db",
                "Upper": "O",
                "images":
                    [
                        {
                            "width": "50",
                            "height": "50",
                            "spriteSheeet": "images/colourBlots.svg",
                            "backgroundPositionX": "-122",
                            "centerBackgroundPositionX": "-122",
                            "backgroundPositionY": "-69",
                            "centerBackgroundPositionY": "-69",
                            "backgroundSize": "475%",
                            "type": "Oranžová",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/colours/Colours_007_Oranzova.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "40",
                            "height": "50",
                            "spriteSheeet": "images/colourShapes4.svg",
                            "backgroundPositionX": "-131",
                            "centerBackgroundPositionX": "-131",
                            "backgroundPositionY": "-9",
                            "centerBackgroundPositionY": "-9",
                            "backgroundSize": "450%",
                            "type": "Oranžová hvězda",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/colourShapes/ColourShapes_016_OranzovaHvezda.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "35",
                            "height": "50",
                            "spriteSheeet": "images/vegetables.jpg",
                            "backgroundPositionX": "-70",
                            "centerBackgroundPositionX": "-70",
                            "backgroundPositionY": "-1",
                            "centerBackgroundPositionY": "-1",
                            "backgroundSize": "600%",
                            "type": "Okurka",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/food/FruitsAndVegetables_003_Okurka.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "40",
                            "height": "50",
                            "spriteSheeet": "images/animals.svg",
                            "backgroundPositionX": "-214",
                            "centerBackgroundPositionX": "-214",
                            "backgroundPositionY": "-318",
                            "centerBackgroundPositionY": "-318",
                            "backgroundSize": "1200%",
                            "type": "Ovce",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/animals/Animals_035_Ovce.mp3",
                                    "volume": 1,
                                    "preload": true
                                },
                            "soundEffect":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/animals/soundEffects/sheeplings-80615.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "40",
                            "height": "50",
                            "spriteSheeet": "images/animals.svg",
                            "backgroundPositionX": "-272",
                            "centerBackgroundPositionX": "-272",
                            "backgroundPositionY": "-382",
                            "centerBackgroundPositionY": "-382",
                            "backgroundSize": "1250%",
                            "type": "Osel",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/animals/Animals_039_Osel.mp3",
                                    "volume": 1,
                                    "preload": true
                                },
                            "soundEffect":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/animals/soundEffects/jumento-101690.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "120",
                            "height": "50",
                            "spriteSheeet": "images/numbers.svg",
                            "backgroundPositionX": "-130",
                            "centerBackgroundPositionX": "-161",
                            "backgroundPositionY": "-152",
                            "centerBackgroundPositionY": "-170",
                            "backgroundSize": "213%",
                            "type": "Osm",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/numbers/Numbers_009_8.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "100",
                            "height": "50",
                            "spriteSheeet": "images/bodyParts.svg",
                            "backgroundPositionX": "-187",
                            "centerBackgroundPositionX": "-94",
                            "backgroundPositionY": "-286",
                            "centerBackgroundPositionY": "-144",
                            "backgroundSize": "325%",
                            "type": "Oko",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/bodyParts/Body Parts_002_Oko.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "65",
                            "height": "50",
                            "spriteSheeet": "images/homeObjects.svg",
                            "backgroundPositionX": "-183",
                            "centerBackgroundPositionX": "-141",
                            "backgroundPositionY": "-489",
                            "centerBackgroundPositionY": "-376",
                            "backgroundSize": "850%",
                            "type": "Okno",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/homeObjects/Home Objects_010_Okno.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "50",
                            "height": "50",
                            "spriteSheeet": "images/colourShapes1.svg",
                            "backgroundPositionX": "-143",
                            "centerBackgroundPositionX": "-143",
                            "backgroundPositionY": "-16",
                            "centerBackgroundPositionY": "-16",
                            "backgroundSize": "400%",
                            "type": "Obdélník",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/shapes/Shapes_004_Obdelnik.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "40",
                            "height": "50",
                            "spriteSheeet": "images/colourShapes3.svg",
                            "backgroundPositionX": "-88",
                            "centerBackgroundPositionX": "-88",
                            "backgroundPositionY": "-9",
                            "centerBackgroundPositionY": "-9",
                            "backgroundSize": "450%",
                            "type": "Ovál",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/shapes/Shapes_010_Oval.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        }
                    ]
            },
        "letterP":
            {
                "sound":
                    {
                        "html5": true,
                        "src": "audio/cs-CZ/Adriana/letterP.mp3",
                        "volume": 1,
                        "preload": true
                    },
                "colour": "#c56133",
                "Upper": "P",
                "images":
                    [
                        {
                            "width": "50",
                            "height": "50",
                            "spriteSheeet": "images/vegetables.jpg",
                            "backgroundPositionX": "-60",
                            "centerBackgroundPositionX": "-60",
                            "backgroundPositionY": "-150",
                            "centerBackgroundPositionY": "-150",
                            "backgroundSize": "575%",
                            "type": "Paprika",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/food/FruitsAndVegetables_014_PaprikaZelena.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "55",
                            "height": "50",
                            "spriteSheeet": "images/fruits.jpg",
                            "backgroundPositionX": "-2",
                            "centerBackgroundPositionX": "-2",
                            "backgroundPositionY": "-4",
                            "centerBackgroundPositionY": "-4",
                            "backgroundSize": "450%",
                            "type": "Pomeranč",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/food/FruitsAndVegetables_018_Pomeranc.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "45",
                            "height": "50",
                            "spriteSheeet": "images/toys.svg",
                            "backgroundPositionX": "-6",
                            "centerBackgroundPositionX": "-6",
                            "backgroundPositionY": "-55",
                            "centerBackgroundPositionY": "-55",
                            "backgroundSize": "600%",
                            "type": "Pirátská loď",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/toys/Toys_006_PiratskaLod.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "65",
                            "height": "50",
                            "spriteSheeet": "images/toys.svg",
                            "backgroundPositionX": "-162",
                            "centerBackgroundPositionX": "-125",
                            "backgroundPositionY": "-65",
                            "centerBackgroundPositionY": "-51",
                            "backgroundSize": "450%",
                            "type": "Ponorka",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/toys/Toys_009_Ponorka.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "35",
                            "height": "50",
                            "spriteSheeet": "images/animals.svg",
                            "backgroundPositionX": "-101",
                            "centerBackgroundPositionX": "-101",
                            "backgroundPositionY": "-40",
                            "centerBackgroundPositionY": "-40",
                            "backgroundSize": "1200%",
                            "type": "Páv",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/animals/Animals_005_Pav.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "45",
                            "height": "50",
                            "spriteSheeet": "images/animals.svg",
                            "backgroundPositionX": "-163",
                            "centerBackgroundPositionX": "-163",
                            "backgroundPositionY": "-86",
                            "centerBackgroundPositionY": "-86",
                            "backgroundSize": "1100%",
                            "type": "Pelikán",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/animals/Animals_006_Pelikan.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "45",
                            "height": "50",
                            "spriteSheeet": "images/animals.svg",
                            "backgroundPositionX": "-61",
                            "centerBackgroundPositionX": "-61",
                            "backgroundPositionY": "-159",
                            "centerBackgroundPositionY": "-159",
                            "backgroundSize": "1400%",
                            "type": "Panda",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/animals/Animals_011_Panda.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "60",
                            "height": "50",
                            "spriteSheeet": "images/animals.svg",
                            "backgroundPositionX": "-1",
                            "centerBackgroundPositionX": "-1",
                            "backgroundPositionY": "-428",
                            "centerBackgroundPositionY": "-356",
                            "backgroundSize": "1100%",
                            "type": "Prase",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/animals/Animals_031_Prase.mp3",
                                    "volume": 1,
                                    "preload": true
                                },
                            "soundEffect":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/animals/soundEffects/pig-oink-47167.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "45",
                            "height": "50",
                            "spriteSheeet": "images/animals.svg",
                            "backgroundPositionX": "-145",
                            "centerBackgroundPositionX": "-144",
                            "backgroundPositionY": "-451",
                            "centerBackgroundPositionY": "-451",
                            "backgroundSize": "1500%",
                            "type": "Pes",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/animals/Animals_033_Pes.mp3",
                                    "volume": 1,
                                    "preload": true
                                },
                            "soundEffect":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/animals/soundEffects/barking-3-47779.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "120",
                            "height": "50",
                            "spriteSheeet": "images/numbers.svg",
                            "backgroundPositionX": "-130",
                            "centerBackgroundPositionX": "-161",
                            "backgroundPositionY": "-5",
                            "centerBackgroundPositionY": "-2",
                            "backgroundSize": "213%",
                            "type": "Pět",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/numbers/Numbers_006_5.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "60",
                            "height": "50",
                            "spriteSheeet": "images/bodyParts.svg",
                            "backgroundPositionX": "-33",
                            "centerBackgroundPositionX": "-28",
                            "backgroundPositionY": "-145",
                            "centerBackgroundPositionY": "-121",
                            "backgroundSize": "300%",
                            "type": "Pusa",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/bodyParts/Body Parts_003_Pusa.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "85",
                            "height": "50",
                            "spriteSheeet": "images/homeObjects.svg",
                            "backgroundPositionX": "-108",
                            "centerBackgroundPositionX": "-64",
                            "backgroundPositionY": "-208",
                            "centerBackgroundPositionY": "-121",
                            "backgroundSize": "750%",
                            "type": "Postel",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/homeObjects/Home Objects_011_Postel.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "60",
                            "height": "50",
                            "spriteSheeet": "images/homeObjects.svg",
                            "backgroundPositionX": "-141",
                            "centerBackgroundPositionX": "-117",
                            "backgroundPositionY": "-553",
                            "centerBackgroundPositionY": "-461",
                            "backgroundSize": "1200%",
                            "type": "Polštář",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/homeObjects/Home Objects_012_Polstar.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "35",
                            "height": "50",
                            "spriteSheeet": "images/transportation.svg",
                            "backgroundPositionX": "-176",
                            "centerBackgroundPositionX": "-176",
                            "backgroundPositionY": "3",
                            "centerBackgroundPositionY": "3",
                            "backgroundSize": "600%",
                            "type": "Padák",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/transportation/Transportation_011_Padak.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "80",
                            "height": "50",
                            "spriteSheeet": "images/transportation.svg",
                            "backgroundPositionX": "-177",
                            "centerBackgroundPositionX": "-111",
                            "backgroundPositionY": "-201",
                            "centerBackgroundPositionY": "-126",
                            "backgroundSize": "325%",
                            "type": "Plachetnice",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/transportation/Transportation_012_Plachetnice.mp3",
                                    "volume": 1,
                                    "preload": true
                                },
                            "soundEffect":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/transportation/soundEffects/cannon-shot-6153.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "50",
                            "height": "50",
                            "spriteSheeet": "images/colourShapes3.svg",
                            "backgroundPositionX": "-4",
                            "centerBackgroundPositionX": "-4",
                            "backgroundPositionY": "-14",
                            "centerBackgroundPositionY": "-14",
                            "backgroundSize": "400%",
                            "type": "Půlměsíc",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/shapes/Shapes_009_Pulmesic.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "40",
                            "height": "50",
                            "spriteSheeet": "images/colourShapes4.svg",
                            "backgroundPositionX": "-52",
                            "centerBackgroundPositionX": "-52",
                            "backgroundPositionY": "-11",
                            "centerBackgroundPositionY": "-11",
                            "backgroundSize": "460%",
                            "type": "Pětiúhelník",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/shapes/Shapes_013_Petiuhelnik.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        }
                    ]
            },
        "letterQ":
            {
                "sound":
                    {
                        "html5": true,
                        "src": "audio/cs-CZ/Adriana/letterQ.mp3",
                        "volume": 1,
                        "preload": true
                    },
                "colour": "#2f2aa0",
                "Upper": "Q",
                "images":
                    [
                        {
                            "width": "50",
                            "height": "50",
                            "spriteSheeet": "images/random/shutterstock_1617896356_Quasimodo.svg",
                            "backgroundPositionX": "0",
                            "centerBackgroundPositionX": "0",
                            "backgroundPositionY": "0",
                            "centerBackgroundPositionY": "0",
                            "backgroundSize": "100%",
                            "type": "Quasimodo",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/random/Random_003_Quasimodo.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        }
                    ]
            },
        "letterR":
            {
                "sound":
                    {
                        "html5": true,
                        "src": "audio/cs-CZ/Adriana/letterR.mp3",
                        "volume": 1,
                        "preload": true
                    },
                "colour": "#632819",
                "Upper": "R",
                "images":
                    [
                        {
                            "width": "50",
                            "height": "50",
                            "spriteSheeet": "images/colourBlots.svg",
                            "backgroundPositionX": "-66",
                            "centerBackgroundPositionX": "-66",
                            "backgroundPositionY": "-6",
                            "centerBackgroundPositionY": "-6",
                            "backgroundSize": "475%",
                            "type": "Růžová",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/colours/Colours_002_Ruzova.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "40",
                            "height": "50",
                            "spriteSheeet": "images/colourShapes1.svg",
                            "backgroundPositionX": "-86",
                            "centerBackgroundPositionX": "-86",
                            "backgroundPositionY": "-8",
                            "centerBackgroundPositionY": "-8",
                            "backgroundSize": "440%",
                            "type": "Růžový trojúhelník",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/colourShapes/ColourShapes_003_RuzovyTrojuhelnik.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "40",
                            "height": "50",
                            "spriteSheeet": "images/colourShapes2.svg",
                            "backgroundPositionX": "-50",
                            "centerBackgroundPositionX": "-50",
                            "backgroundPositionY": "-8",
                            "centerBackgroundPositionY": "-8",
                            "backgroundSize": "450%",
                            "type": "Růžový kosočtverec",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/colourShapes/ColourShapes_006_RuzovyKosoctverec.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "40",
                            "height": "50",
                            "spriteSheeet": "images/colourShapes3.svg",
                            "backgroundPositionX": "-88",
                            "centerBackgroundPositionX": "-88",
                            "backgroundPositionY": "-9",
                            "centerBackgroundPositionY": "-9",
                            "backgroundSize": "450%",
                            "type": "Růžový ovál",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/colourShapes/ColourShapes_011_RuzovyOval.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "45",
                            "height": "50",
                            "spriteSheeet": "images/colourShapes4.svg",
                            "backgroundPositionX": "-95",
                            "centerBackgroundPositionX": "-95",
                            "backgroundPositionY": "-12",
                            "centerBackgroundPositionY": "-12",
                            "backgroundSize": "425%",
                            "type": "Růžové srdce",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/colourShapes/ColourShapes_015_RuzoveSrdce.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "55",
                            "height": "50",
                            "spriteSheeet": "images/vegetables.jpg",
                            "backgroundPositionX": "-3",
                            "centerBackgroundPositionX": "-3",
                            "backgroundPositionY": "-144",
                            "centerBackgroundPositionY": "-144",
                            "backgroundSize": "500%",
                            "type": "Rajče",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/food/FruitsAndVegetables_013_Rajce.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "65",
                            "height": "50",
                            "spriteSheeet": "images/animals.svg",
                            "backgroundPositionX": "-530",
                            "centerBackgroundPositionX": "-522",
                            "backgroundPositionY": "-180",
                            "centerBackgroundPositionY": "-127",
                            "backgroundSize": "1150%",
                            "type": "Ryba",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/animals/Animals_016_Ryba.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "45",
                            "height": "50",
                            "spriteSheeet": "images/bodyParts.svg",
                            "backgroundPositionX": "-38",
                            "centerBackgroundPositionX": "-38",
                            "backgroundPositionY": "-39",
                            "centerBackgroundPositionY": "-39",
                            "backgroundSize": "250%",
                            "type": "Ruka",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/bodyParts/Body Parts_004_Ruka.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "70",
                            "height": "50",
                            "spriteSheeet": "images/transportation.svg",
                            "backgroundPositionX": "-243",
                            "centerBackgroundPositionX": "-173",
                            "backgroundPositionY": "-186",
                            "centerBackgroundPositionY": "-132",
                            "backgroundSize": "450%",
                            "type": "Rychlovlak",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/transportation/Transportation_013_Rychlovlak.mp3",
                                    "volume": 1,
                                    "preload": true
                                },
                            "soundEffect":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/transportation/soundEffects/031973_trnelec_passby-regional-french-train-ter-at-high-speed-close-up_pierre-marie-blind_schoeps-mswav-62458.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "80",
                            "height": "50",
                            "spriteSheeet": "images/transportation.svg",
                            "backgroundPositionX": "-5",
                            "centerBackgroundPositionX": "-3",
                            "backgroundPositionY": "-264",
                            "centerBackgroundPositionY": "-166",
                            "backgroundSize": "400%",
                            "type": "Rychločlun",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/transportation/Transportation_014_Rychloclun.mp3",
                                    "volume": 1,
                                    "preload": true
                                },
                            "soundEffect":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/transportation/soundEffects/boat-on-river-26388.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        }
                    ]
            },
        "letterRSoft":
            {
                "sound":
                    {
                        "html5": true,
                        "src": "audio/cs-CZ/Adriana/letterRSoft.mp3",
                        "volume": 1,
                        "preload": true
                    },
                "colour": "#632819",
                "Upper": "Ř",
                "images":
                    [
                        {
                            "width": "45",
                            "height": "50",
                            "spriteSheeet": "images/vegetables.jpg",
                            "backgroundPositionX": "-71",
                            "centerBackgroundPositionX": "-66",
                            "backgroundPositionY": "-60",
                            "centerBackgroundPositionY": "-60",
                            "backgroundSize": "500%",
                            "type": "Řepa červená",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/food/FruitsAndVegetables_009_RepaCervena.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        }
                    ]
            },
        "letterS":
            {
                "sound":
                    {
                        "html5": true,
                        "src": "audio/cs-CZ/Adriana/letterS.mp3",
                        "volume": 1,
                        "preload": true
                    },
                "colour": "#7dfc00",
                "Upper": "S",
                "images":
                    [
                        {
                            "width": "50",
                            "height": "50",
                            "spriteSheeet": "images/animals.svg",
                            "backgroundPositionX": "-242",
                            "centerBackgroundPositionX": "-242",
                            "backgroundPositionY": "-80",
                            "centerBackgroundPositionY": "-80",
                            "backgroundSize": "1150%",
                            "type": "Sup",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/animals/Animals_007_Sup.mp3",
                                    "volume": 1,
                                    "preload": true
                                },
                            "soundEffect":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/animals/soundEffects/vulture-88478.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "45",
                            "height": "50",
                            "spriteSheeet": "images/animals.svg",
                            "backgroundPositionX": "-120",
                            "centerBackgroundPositionX": "-120",
                            "backgroundPositionY": "-141",
                            "centerBackgroundPositionY": "-141",
                            "backgroundSize": "1100%",
                            "type": "Slon",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/animals/Animals_013_Slon.mp3",
                                    "volume": 1,
                                    "preload": true
                                },
                            "soundEffect":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/animals/soundEffects/elephant-trumpets-growls-6047.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "40",
                            "height": "50",
                            "spriteSheeet": "images/animals.svg",
                            "backgroundPositionX": "-377",
                            "centerBackgroundPositionX": "-376",
                            "backgroundPositionY": "-468",
                            "centerBackgroundPositionY": "-469",
                            "backgroundSize": "1700%",
                            "type": "Slepice",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/animals/Animals_036_Slepice.mp3",
                                    "volume": 1,
                                    "preload": true
                                },
                            "soundEffect":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/animals/soundEffects/chicken-single-alarm-call-6056.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "120",
                            "height": "50",
                            "spriteSheeet": "images/numbers.svg",
                            "backgroundPositionX": "-130",
                            "centerBackgroundPositionX": "-161",
                            "backgroundPositionY": "-103",
                            "centerBackgroundPositionY": "-149",
                            "backgroundSize": "213%",
                            "type": "Sedm",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/numbers/Numbers_008_7.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "50",
                            "height": "50",
                            "spriteSheeet": "images/homeObjects.svg",
                            "backgroundPositionX": "-454",
                            "centerBackgroundPositionX": "-454",
                            "backgroundPositionY": "-18",
                            "centerBackgroundPositionY": "-18",
                            "backgroundSize": "1200%",
                            "type": "Stůl",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/homeObjects/Home Objects_013_Stul.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "45",
                            "height": "50",
                            "spriteSheeet": "images/colourShapes4.svg",
                            "backgroundPositionX": "-95",
                            "centerBackgroundPositionX": "-95",
                            "backgroundPositionY": "-12",
                            "centerBackgroundPositionY": "-12",
                            "backgroundSize": "425%",
                            "type": "Srdce",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/shapes/Shapes_014_Srdce.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        }
                    ]
            },
        "letterSSoft":
            {
                "sound":
                    {
                        "html5": true,
                        "src": "audio/cs-CZ/Adriana/letterSSoft.mp3",
                        "volume": 1,
                        "preload": true
                    },
                "colour": "#7dfc00",
                "Upper": "Š",
                "images":
                    [
                        {
                            "width": "50",
                            "height": "50",
                            "spriteSheeet": "images/colourBlots.svg",
                            "backgroundPositionX": "-66",
                            "centerBackgroundPositionX": "-66",
                            "backgroundPositionY": "-131",
                            "centerBackgroundPositionY": "-131",
                            "backgroundSize": "475%",
                            "type": "Šedá",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/colours/Colours_010_Seda.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "45",
                            "height": "50",
                            "spriteSheeet": "images/animals.svg",
                            "backgroundPositionX": "-401",
                            "centerBackgroundPositionX": "-401",
                            "backgroundPositionY": "-167",
                            "centerBackgroundPositionY": "-167",
                            "backgroundSize": "1100%",
                            "type": "Šimpanz",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/animals/Animals_022_Simpanz.mp3",
                                    "volume": 1,
                                    "preload": true
                                },
                            "soundEffect":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/animals/soundEffects/monkey-scream-6407.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "45",
                            "height": "50",
                            "spriteSheeet": "images/animals.svg",
                            "backgroundPositionX": "-18",
                            "centerBackgroundPositionX": "-19",
                            "backgroundPositionY": "-492",
                            "centerBackgroundPositionY": "-494",
                            "backgroundSize": "1400%",
                            "type": "Šnek",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/animals/Animals_038_Snek.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "120",
                            "height": "50",
                            "spriteSheeet": "images/numbers.svg",
                            "backgroundPositionX": "-130",
                            "centerBackgroundPositionX": "-161",
                            "backgroundPositionY": "-54",
                            "centerBackgroundPositionY": "-22",
                            "backgroundSize": "213%",
                            "type": "Šest",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/numbers/Numbers_007_6.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "50",
                            "height": "50",
                            "spriteSheeet": "images/dairyProducts.jpg",
                            "backgroundPositionX": "-3",
                            "centerBackgroundPositionX": "-3",
                            "backgroundPositionY": "-109",
                            "centerBackgroundPositionY": "-109",
                            "backgroundSize": "325%",
                            "type": "Šlehačka",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/dairyProducts/Dairy Products_005_Slehacka.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "40",
                            "height": "50",
                            "spriteSheeet": "images/colourShapes2.svg",
                            "backgroundPositionX": "-78",
                            "centerBackgroundPositionX": "-78",
                            "backgroundPositionY": "-5",
                            "centerBackgroundPositionY": "-5",
                            "backgroundSize": "400%",
                            "type": "Šestiúhelník",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/shapes/Shapes_007_Sestiuhelnik.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        }
                    ]
            },
        "letterT":
            {
                "sound":
                    {
                        "html5": true,
                        "src": "audio/cs-CZ/Adriana/letterT.mp3",
                        "volume": 1,
                        "preload": true
                    },
                "colour": "#29bdab",
                "Upper": "T",
                "images":
                    [
                        {
                            "width": "50",
                            "height": "50",
                            "spriteSheeet": "images/colourBlots.svg",
                            "backgroundPositionX": "-178",
                            "centerBackgroundPositionX": "-178",
                            "backgroundPositionY": "-69",
                            "centerBackgroundPositionY": "-69",
                            "backgroundSize": "475%",
                            "type": "Tyrkysová",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/colours/Colours_008_Tyrkysova.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "40",
                            "height": "50",
                            "spriteSheeet": "images/fruits.jpg",
                            "backgroundPositionX": "-102",
                            "centerBackgroundPositionX": "-102",
                            "backgroundPositionY": "-62",
                            "centerBackgroundPositionY": "-62",
                            "backgroundSize": "600%",
                            "type": "Třešně",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/food/FruitsAndVegetables_025_Tresne.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "40",
                            "height": "50",
                            "spriteSheeet": "images/animals.svg",
                            "backgroundPositionX": "-43",
                            "centerBackgroundPositionX": "-44",
                            "backgroundPositionY": "-75",
                            "centerBackgroundPositionY": "-74",
                            "backgroundSize": "1300%",
                            "type": "Tučňák",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/animals/Animals_004_Tucnak.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "55",
                            "height": "50",
                            "spriteSheeet": "images/animals.svg",
                            "backgroundPositionX": "-280",
                            "centerBackgroundPositionX": "-255",
                            "backgroundPositionY": "-77",
                            "centerBackgroundPositionY": "-70",
                            "backgroundSize": "1000%",
                            "type": "Tukan",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/animals/Animals_008_Tukan.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "50",
                            "height": "50",
                            "spriteSheeet": "images/animals.svg",
                            "backgroundPositionX": "-63",
                            "centerBackgroundPositionX": "-63",
                            "backgroundPositionY": "-242",
                            "centerBackgroundPositionY": "-242",
                            "backgroundSize": "1300%",
                            "type": "Tygr",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/animals/Animals_018_Tygr.mp3",
                                    "volume": 1,
                                    "preload": true
                                },
                            "soundEffect":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/animals/soundEffects/tiger-87706.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "120",
                            "height": "50",
                            "spriteSheeet": "images/numbers.svg",
                            "backgroundPositionX": "-6",
                            "centerBackgroundPositionX": "-3",
                            "backgroundPositionY": "-152",
                            "centerBackgroundPositionY": "-170",
                            "backgroundSize": "213%",
                            "type": "Tři",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/numbers/Numbers_004_3.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "50",
                            "height": "50",
                            "spriteSheeet": "images/musicalInstruments.svg",
                            "backgroundPositionX": "-275",
                            "centerBackgroundPositionX": "-275",
                            "backgroundPositionY": "-87",
                            "centerBackgroundPositionY": "-87",
                            "backgroundSize": "900%",
                            "type": "Tamburína",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/musicalInstruments/MusicalInstruments_005_Tamburina.mp3",
                                    "volume": 1,
                                    "preload": true
                                },
                            "soundEffect":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/musicalInstruments/soundEffects/tambourine-2-bars-loop-90bpm-44-46139.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "110",
                            "height": "50",
                            "spriteSheeet": "images/musicalInstruments.svg",
                            "backgroundPositionX": "-152",
                            "centerBackgroundPositionX": "-69",
                            "backgroundPositionY": "-63",
                            "centerBackgroundPositionY": "-30",
                            "backgroundSize": "450%",
                            "type": "Trubka",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/musicalInstruments/MusicalInstruments_006_Trubka.mp3",
                                    "volume": 1,
                                    "preload": true
                                },
                            "soundEffect":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/musicalInstruments/soundEffects/trumpet-e4-14829.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "50",
                            "height": "50",
                            "spriteSheeet": "images/homeObjects.svg",
                            "backgroundPositionX": "-240",
                            "centerBackgroundPositionX": "-240",
                            "backgroundPositionY": "-440",
                            "centerBackgroundPositionY": "-441",
                            "backgroundSize": "1000%",
                            "type": "Televize",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/homeObjects/Home Objects_014_Televize.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "40",
                            "height": "50",
                            "spriteSheeet": "images/buildings.svg",
                            "backgroundPositionX": "-20",
                            "centerBackgroundPositionX": "-20",
                            "backgroundPositionY": "-12",
                            "centerBackgroundPositionY": "-12",
                            "backgroundSize": "450%",
                            "type": "Týpí",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/buildings/Buildings_003_Typi.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "90",
                            "height": "50",
                            "spriteSheeet": "images/transportation.svg",
                            "backgroundPositionX": "-6",
                            "centerBackgroundPositionX": "-3",
                            "backgroundPositionY": "-1",
                            "centerBackgroundPositionY": "-1",
                            "backgroundSize": "425%",
                            "type": "Taxi",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/transportation/Transportation_015_Taxi.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "60",
                            "height": "50",
                            "spriteSheeet": "images/transportation.svg",
                            "backgroundPositionX": "-110",
                            "centerBackgroundPositionX": "-92",
                            "backgroundPositionY": "-81",
                            "centerBackgroundPositionY": "-73",
                            "backgroundSize": "375%",
                            "type": "Tramvaj",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/transportation/Transportation_016_Tramvaj.mp3",
                                    "volume": 1,
                                    "preload": true
                                },
                            "soundEffect":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/transportation/soundEffects/tram_bell_ride_door-18009.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "40",
                            "height": "50",
                            "spriteSheeet": "images/colourShapes1.svg",
                            "backgroundPositionX": "-86",
                            "centerBackgroundPositionX": "-86",
                            "backgroundPositionY": "-8",
                            "centerBackgroundPositionY": "-8",
                            "backgroundSize": "440%",
                            "type": "Trojúhelník",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/shapes/Shapes_003_Trojuhelnik.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "50",
                            "height": "50",
                            "spriteSheeet": "images/colourShapes3.svg",
                            "backgroundPositionX": "-51",
                            "centerBackgroundPositionX": "-51",
                            "backgroundPositionY": "-14",
                            "centerBackgroundPositionY": "-14",
                            "backgroundSize": "400%",
                            "type": "Trojúhelník",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/shapes/Shapes_003_Trojuhelnik.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        }
                    ]
            },
        "letterTSoft":
            {
                "sound":
                    {
                        "html5": true,
                        "src": "audio/cs-CZ/Adriana/letterTSoft.mp3",
                        "volume": 1,
                        "preload": true
                    },
                "colour": "#29bdab",
                "Upper": "Ť",
                "images":
                    [
                        {
                            "width": "50",
                            "height": "50",
                            "spriteSheeet": "images/random/shutterstock_541832350_Tapka.svg",
                            "backgroundPositionX": "0",
                            "centerBackgroundPositionX": "0",
                            "backgroundPositionY": "0",
                            "centerBackgroundPositionY": "0",
                            "backgroundSize": "100%",
                            "type": "Ťapka",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/random/Random_004_Tapka.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        }
                    ]
            },
        "letterU":
            {
                "sound":
                    {
                        "html5": true,
                        "src": "audio/cs-CZ/Adriana/letterU.mp3",
                        "volume": 1,
                        "preload": true
                    },
                "colour": "#f22020",
                "Upper": "U",
                "images":
                    [
                        {
                            "width": "30",
                            "height": "50",
                            "spriteSheeet": "images/bodyParts.svg",
                            "backgroundPositionX": "-90",
                            "centerBackgroundPositionX": "-90",
                            "backgroundPositionY": "-46",
                            "centerBackgroundPositionY": "-46",
                            "backgroundSize": "400%",
                            "type": "Ucho",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/bodyParts/Body Parts_005_Ucho.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        }
                    ]
            },
        "letterV":
            {
                "sound":
                    {
                        "html5": true,
                        "src": "audio/cs-CZ/Adriana/letterV.mp3",
                        "volume": 1,
                        "preload": true
                    },
                "colour": "#96341c",
                "Upper": "V",
                "images":
                    [
                        /*{
                            "width": "55",
                            "height": "50",
                            "spriteSheeet": "images/toys.svg",
                            "backgroundPositionX": "-239",
                            "centerBackgroundPositionX": "-239",
                            "backgroundPositionY": "-68",
                            "centerBackgroundPositionY": "-68",
                            "backgroundSize": "550%",
                            "type": "Vrtulník",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/toys/Toys_010_Vrtulnik.mp3",
                                    "volume": 1,
                                    "preload": true
                                },
                            "soundEffect":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/transportation/soundEffects/helicopter-flyby-8114.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },*/
                        {
                            "width": "45",
                            "height": "50",
                            "spriteSheeet": "images/animals.svg",
                            "backgroundPositionX": "-145",
                            "centerBackgroundPositionX": "-143",
                            "backgroundPositionY": "-119",
                            "centerBackgroundPositionY": "-119",
                            "backgroundSize": "950%",
                            "type": "Velbloud",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/animals/Animals_014_Velbloud.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "85",
                            "height": "50",
                            "spriteSheeet": "images/homeObjects.svg",
                            "backgroundPositionX": "-750",
                            "centerBackgroundPositionX": "-940",
                            "backgroundPositionY": "-286",
                            "centerBackgroundPositionY": "-169",
                            "backgroundSize": "1000%",
                            "type": "Věšák",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/homeObjects/Home Objects_015_Vesak.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "35",
                            "height": "50",
                            "spriteSheeet": "images/homeObjects.svg",
                            "backgroundPositionX": "-261",
                            "centerBackgroundPositionX": "-261",
                            "backgroundPositionY": "-193",
                            "centerBackgroundPositionY": "-193",
                            "backgroundSize": "1200%",
                            "type": "Větrák",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/homeObjects/Home Objects_016_Vetrak.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "90",
                            "height": "50",
                            "spriteSheeet": "images/transportation.svg",
                            "backgroundPositionX": "-126",
                            "centerBackgroundPositionX": "-70",
                            "backgroundPositionY": "-4",
                            "centerBackgroundPositionY": "-2",
                            "backgroundSize": "425%",
                            "type": "Vrtulník",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/transportation/Transportation_017_Vrtulnik.mp3",
                                    "volume": 1,
                                    "preload": true
                                },
                            "soundEffect":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/transportation/soundEffects/helicopter-flyby-8114.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        }
                    ]
            },
        "letterW":
            {
                "sound":
                    {
                        "html5": true,
                        "src": "audio/cs-CZ/Adriana/letterW.mp3",
                        "volume": 1,
                        "preload": true
                    },
                "colour": "#b732cc",
                "Upper": "W",
                "images":
                    [
                        {
                            "width": "50",
                            "height": "50",
                            "spriteSheeet": "images/random/shutterstock_271533809_WC.svg",
                            "backgroundPositionX": "0",
                            "centerBackgroundPositionX": "0",
                            "backgroundPositionY": "0",
                            "centerBackgroundPositionY": "0",
                            "backgroundSize": "100%",
                            "type": "WC",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/random/Random_005_WC.mp3",
                                    "volume": 1,
                                    "preload": true
                                },
                            "soundEffect":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/random/soundEffects/toilet-flush-refilling-of-toilet-tank-29609.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        }
                    ]
            },
        "letterX":
            {
                "sound":
                    {
                        "html5": true,
                        "src": "audio/cs-CZ/Adriana/letterX.mp3",
                        "volume": 1,
                        "preload": true
                    },
                "colour": "#c3a5b4",
                "Upper": "X",
                "images":
                    [
                        {
                            "width": "65",
                            "height": "50",
                            "spriteSheeet": "images/musicalInstruments.svg",
                            "backgroundPositionX": "-254",
                            "centerBackgroundPositionX": "-196",
                            "backgroundPositionY": "-102",
                            "centerBackgroundPositionY": "-78",
                            "backgroundSize": "500%",
                            "type": "Xylofon",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/musicalInstruments/MusicalInstruments_007_Xylofon.mp3",
                                    "volume": 1,
                                    "preload": true
                                },
                            "soundEffect":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/musicalInstruments/soundEffects/xylophone-tones-105880.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        }
                    ]
            },
        "letterY":
            {
                "sound":
                    {
                        "html5": true,
                        "src": "audio/cs-CZ/Adriana/letterY.mp3",
                        "volume": 1,
                        "preload": true
                    },
                "colour": "#0ec434",
                "Upper": "Y",
                "images":
                    [
                        {
                            "width": "40",
                            "height": "50",
                            "spriteSheeet": "images/random/shutterstock_1294860409_Yetti.svg",
                            "backgroundPositionX": "0",
                            "centerBackgroundPositionX": "0",
                            "backgroundPositionY": "0",
                            "centerBackgroundPositionY": "0",
                            "backgroundSize": "100%",
                            "type": "Yetti",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/random/Random_006_Yetti.mp3",
                                    "volume": 1,
                                    "preload": true
                                },
                            "soundEffect":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/random/soundEffects/monster-howl-85304.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        }
                    ]
            },
        "letterZ":
            {
                "sound":
                    {
                        "html5": true,
                        "src": "audio/cs-CZ/Adriana/letterZ.mp3",
                        "volume": 1,
                        "preload": true
                    },
                "colour": "#228c68",
                "Upper": "Z",
                "images":
                    [
                        {
                            "width": "50",
                            "height": "50",
                            "spriteSheeet": "images/colourBlots.svg",
                            "backgroundPositionX": "-9",
                            "centerBackgroundPositionX": "-9",
                            "backgroundPositionY": "-69",
                            "centerBackgroundPositionY": "-69",
                            "backgroundSize": "475%",
                            "type": "Zelená",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/colours/Colours_005_Zelena.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "50",
                            "height": "50",
                            "spriteSheeet": "images/colourShapes2.svg",
                            "backgroundPositionX": "-8",
                            "centerBackgroundPositionX": "-8",
                            "backgroundPositionY": "-14",
                            "centerBackgroundPositionY": "-14",
                            "backgroundSize": "400%",
                            "type": "Zelený lichoběžník",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/colourShapes/ColourShapes_005_ZelenyLichobeznik.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "50",
                            "height": "50",
                            "spriteSheeet": "images/colourShapes3.svg",
                            "backgroundPositionX": "-140",
                            "centerBackgroundPositionX": "-140",
                            "backgroundPositionY": "-15",
                            "centerBackgroundPositionY": "-15",
                            "backgroundSize": "400%",
                            "type": "Zelený kosodélník",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/colourShapes/ColourShapes_012_ZelenyKosodelnik.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "40",
                            "height": "50",
                            "spriteSheeet": "images/colourShapes4.svg",
                            "backgroundPositionX": "-52",
                            "centerBackgroundPositionX": "-52",
                            "backgroundPositionY": "-11",
                            "centerBackgroundPositionY": "-11",
                            "backgroundSize": "460%",
                            "type": "Zelený pětiúhelník",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/colourShapes/ColourShapes_014_ZelenyPetiuhelnik.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "40",
                            "height": "50",
                            "spriteSheeet": "images/vegetables.jpg",
                            "backgroundPositionX": "-196",
                            "centerBackgroundPositionX": "-196",
                            "backgroundPositionY": "-66",
                            "centerBackgroundPositionY": "-66",
                            "backgroundSize": "600%",
                            "type": "Zázvor",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/food/FruitsAndVegetables_012_Zazvor.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "40",
                            "height": "50",
                            "spriteSheeet": "images/animals.svg",
                            "backgroundPositionX": "-91",
                            "centerBackgroundPositionX": "-91",
                            "backgroundPositionY": "-199",
                            "centerBackgroundPositionY": "-199",
                            "backgroundSize": "1300%",
                            "type": "Zebra",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/animals/Animals_019_Zebra.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "45",
                            "height": "50",
                            "spriteSheeet": "images/homeObjects.svg",
                            "backgroundPositionX": "-171",
                            "centerBackgroundPositionX": "-171",
                            "backgroundPositionY": "-232",
                            "centerBackgroundPositionY": "-232",
                            "backgroundSize": "1100%",
                            "type": "Zapalovač",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/homeObjects/Home Objects_017_Zapalovac.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "120",
                            "height": "50",
                            "spriteSheeet": "images/transportation.svg",
                            "backgroundPositionX": "-84",
                            "centerBackgroundPositionX": "-33",
                            "backgroundPositionY": "-241",
                            "centerBackgroundPositionY": "-223",
                            "backgroundSize": "250%",
                            "type": "Zaoceánská loď",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/transportation/Transportation_018_ZaoceanskaLod.mp3",
                                    "volume": 1,
                                    "preload": true
                                },
                            "soundEffect":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/transportation/soundEffects/boat-horn-6204.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        }
                    ]
            },
        "letterZSoft":
            {
                "sound":
                    {
                        "html5": true,
                        "src": "audio/cs-CZ/Adriana/letterZSoft.mp3",
                        "volume": 1,
                        "preload": true
                    },
                "colour": "#228c68",
                "Upper": "Ž",
                "images":
                    [
                        {
                            "width": "50",
                            "height": "50",
                            "spriteSheeet": "images/colourBlots.svg",
                            "backgroundPositionX": "-122",
                            "centerBackgroundPositionX": "-122",
                            "backgroundPositionY": "-6",
                            "centerBackgroundPositionY": "-6",
                            "backgroundSize": "475%",
                            "type": "Žlutá",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/colours/Colours_003_Zluta.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "50",
                            "height": "50",
                            "spriteSheeet": "images/colourShapes1.svg",
                            "backgroundPositionX": "-7",
                            "centerBackgroundPositionX": "-7",
                            "backgroundPositionY": "-14",
                            "centerBackgroundPositionY": "-14",
                            "backgroundSize": "400%",
                            "type": "Žlutý čtverec",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/colourShapes/ColourShapes_001_ZlutyCtverec.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "40",
                            "height": "50",
                            "spriteSheeet": "images/colourShapes2.svg",
                            "backgroundPositionX": "-78",
                            "centerBackgroundPositionX": "-78",
                            "backgroundPositionY": "-5",
                            "centerBackgroundPositionY": "-5",
                            "backgroundSize": "400%",
                            "type": "Žlutý šestiúhelník",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/colourShapes/ColourShapes_007_ZlutySestiuhelnik.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "50",
                            "height": "50",
                            "spriteSheeet": "images/colourShapes3.svg",
                            "backgroundPositionX": "-4",
                            "centerBackgroundPositionX": "-4",
                            "backgroundPositionY": "-14",
                            "centerBackgroundPositionY": "-14",
                            "backgroundSize": "400%",
                            "type": "Žlutý půlměsíc",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/colourShapes/ColourShapes_009_ZlutyPulmesic.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "25",
                            "height": "50",
                            "spriteSheeet": "images/animals.svg",
                            "backgroundPositionX": "-63",
                            "centerBackgroundPositionX": "-63",
                            "backgroundPositionY": "-90",
                            "centerBackgroundPositionY": "-90",
                            "backgroundSize": "1500%",
                            "type": "Žirafa",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/animals/Animals_012_Zirafa.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "45",
                            "height": "50",
                            "spriteSheeet": "images/animals.svg",
                            "backgroundPositionX": "-145",
                            "centerBackgroundPositionX": "-145",
                            "backgroundPositionY": "-4",
                            "centerBackgroundPositionY": "-5",
                            "backgroundSize": "1300%",
                            "type": "Žába",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/animals/Animals_002_Zaba.mp3",
                                    "volume": 1,
                                    "preload": true
                                },
                            "soundEffect":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/animals/soundEffects/frog_quak-81741.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "75",
                            "height": "50",
                            "spriteSheeet": "images/animals.svg",
                            "backgroundPositionX": "-302",
                            "centerBackgroundPositionX": "-210",
                            "backgroundPositionY": "-65",
                            "centerBackgroundPositionY": "-41",
                            "backgroundSize": "675%",
                            "type": "Žralok",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/animals/Animals_009_Zralok.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "75",
                            "height": "50",
                            "spriteSheeet": "images/animals.svg",
                            "backgroundPositionX": "-497",
                            "centerBackgroundPositionX": "-332",
                            "backgroundPositionY": "-242",
                            "centerBackgroundPositionY": "-161",
                            "backgroundSize": "950%",
                            "type": "Želva",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/animals/Animals_023_Zelva.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        },
                        {
                            "width": "35",
                            "height": "50",
                            "spriteSheeet": "images/homeObjects.svg",
                            "backgroundPositionX": "-504",
                            "centerBackgroundPositionX": "-503",
                            "backgroundPositionY": "-264",
                            "centerBackgroundPositionY": "-264",
                            "backgroundSize": "1600%",
                            "type": "Židle",
                            "sound":
                                {
                                    "html5": true,
                                    "src": "audio/cs-CZ/Adriana/homeObjects/Home Objects_018_Zidle.mp3",
                                    "volume": 1,
                                    "preload": true
                                }
                        }
                    ]
            }
    }
    export  default csCZ;